import { ReactEditor } from 'slate-react';
import { Editor, Range } from 'slate';

export type GetSelectedText = (selection?) => string | undefined;

export default function getSelectedText(editor: ReactEditor): GetSelectedText {
  return function (selection?: Range): string | undefined {
    const at = selection || (editor.selection as Range);

    if (at) {
      return Editor.string(editor, at);
    }

    return undefined;
  };
}
